import { apiFetch } from "./client.js";

export type UserSettings = {
  autoCorrectOutgoing: boolean;
};

export type UserSettingsPatch = Partial<UserSettings>;

const DEFAULT_SETTINGS: UserSettings = {
  autoCorrectOutgoing: false,
};

export async function fetchUserSettings(): Promise<UserSettings> {
  const data = await apiFetch("/settings/me");
  return normalizeUserSettings(data);
}

export async function updateUserSettings(patch: UserSettingsPatch): Promise<UserSettings> {
  const data = await apiFetch("/settings/me", {
    method: "PATCH",
    body: JSON.stringify(patch),
  });
  return normalizeUserSettings(data);
}

function normalizeUserSettings(data: unknown): UserSettings {
  if (!data || typeof data !== "object") return DEFAULT_SETTINGS;
  const raw = data as Partial<UserSettings>;
  return {
    autoCorrectOutgoing: Boolean(raw.autoCorrectOutgoing),
  };
}
